export const SERVER_URL = "https://mrt.md.avlab.dev/";
export const pathologyList: Record<
  string,
  { id: string; value: string; color: string }[]
> = {
  hip_joint: [
    {
      id: "noSelected",
      value: "Не выбрано",
      color: "#CD853F",
    },
    {
      id: "cartialgeLession",
      value: "Повреждение хряща",
      color: "#8B0000",
    },

    {
      id: "subchondralCyst",
      value: "Субхондральные кисты",
      color: "#5F9EA0",
    },
    {
      id: "boneMarrowLesion",
      value: "Отек костного мозга",
      color: "#FF4500",
    },
    {
      id: "synovitis",
      value: "Синовит",
      color: "#800080",
    },
  ],
  spine: [
    {
      id: "noSelected",
      value: "Не выбрано",
      color: "#CD853F",
    },
    {
      id: "compressionFracture",
      value: "Компресионный перелом",
      color: "#8B0000",
    },
    {
      id: "declineIntervertebralDiscs",
      value: "Снижение высоты межпозвоночных дисков",
      color: "#5F9EA0",
    },
    {
      id: "marginalBoneGrowths",
      value: "Краевые костные разрастания",
      color: "#FF4500",
    },
    {
      id: "subchondralOsteochondrosis",
      value: "Субхондральный остеохондроз",
      color: "#800080",
    },
    {
      id: "spondylolisthesis",
      value: "Cпондилолистез",
      color: "#BDB76B",
    },
  ],
};
